var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96396 0.193848L6.8018 1.32898C7.36937 1.51817 7.74774 2.08574 7.74774 2.65331V4.92358C7.74774 7.38304 5.47747 9.08574 3.96396 10.0317C2.45045 9.08574 0.180176 7.38304 0.180176 4.92358V2.65331C0.180176 2.08574 0.558554 1.51817 1.12612 1.32898L3.96396 0.193848Z",
    stroke: "#8A43FF",
    strokeWidth: 0.36036
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63965 4.92349L3.58559 5.86943L5.2883 3.97754",
    stroke: "#8A43FF",
    strokeWidth: 0.36036,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.7a3a238b32aaeb1edb2ad3ac4096aec9.svg";
export { ForwardRef as ReactComponent };